import styled from '@optios-frontend-website/shared-ui/src/theme'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

export const Container = styled.div`
  background: ${({ theme }) => theme.colors.primary};
`
export const MenuContainer = styled.div`
  flex: 1;
  background: ${({ theme }) => theme.colors.primary};
  display: flex;
  -webkit-box-pack: justify;
  justify-content: space-between;
  padding: 32px 16px;
  font-weight: ${({ theme }) => theme.fontWeights.bold};
`

export const LastItemsContainer = styled.div`
  display: grid;
  grid-auto-flow: column;
  grid-gap: 12px;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: nowrap;
  max-width: 100%;

  @media (max-width: 768px) {
    justify-content: center;
    gap: 8px;
  }
`

const ButtonWrapperBase = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 42px;
  min-width: 100px;
  width: auto;
  padding: 0 8px;
  border-radius: 20px;
`
export const BookButtonWrapper = styled(ButtonWrapperBase)``
export const ShopifyButtonWrapper = styled(ButtonWrapperBase)``

const ActionButtonBase = styled.a`
  font-size: ${({ theme }) => theme.sizes.xsmall};
  font-family: ${({ theme }) => theme.fonts.primary};
  border: 1px solid ${({ theme }) => theme.colors.secondary};
  border-radius: 20px;
  background: transparent;
  color: ${({ theme }) => theme.colors.feedbackTitle};
  padding: 8px 14px;
  display: flex;
  align-items: center;
  height: 42px;
  font-weight: 600;
  letter-spacing: -0.025em;
  text-decoration: none;
  white-space: nowrap;
  transition: all 0.2s ease-in-out;

  &:hover {
    border-color: ${({ theme }) => theme.colors.secondary};
    color: ${({ theme }) => theme.colors.secondary};
  }
`
export const BookButton = styled(ActionButtonBase)``
export const ShopifyButton = styled(ActionButtonBase)``

export const ButtonIconBase = styled(FontAwesomeIcon)<{ removeMargin?: boolean }>`
  margin-right: ${({ removeMargin }) => (removeMargin ? '0' : '6px')};
  font-size: 0.9em;
  flex-shrink: 0;
`

export const Container2 = styled.div`
  position: absolute;
  width: 100%;
  z-index: 1;
  right: 0;
  @media (max-width: 767px) {
    width: auto;
  }
`
